//import dependencies
import NavigationBar from "./Nav";
import Footer from "./Footer";
//Return the basic page layout to wrap the page content with
let Layout=({children})=>{
    return(
        <>
        <NavigationBar/>
        {children}
        <Footer/>
        </>
    )
}
export default Layout